/**
 * @generated SignedSource<<4ddd38cc6d3919d574d148467a08ad26>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SendMessageInput = {
  attachments?: ReadonlyArray<AttachmentInput> | null | undefined;
  context?: string | null | undefined;
  contextData?: string | null | undefined;
  jobRunId?: any | null | undefined;
  llmConversationId?: any | null | undefined;
  message: string;
};
export type AttachmentInput = {
  handle: string;
};
export type WelcomePageCreateConversationMutation$variables = {
  input: SendMessageInput;
};
export type WelcomePageCreateConversationMutation$data = {
  readonly sendMessage: {
    readonly llmConversation: {
      readonly id: any;
    };
  };
};
export type WelcomePageCreateConversationMutation = {
  response: WelcomePageCreateConversationMutation$data;
  variables: WelcomePageCreateConversationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SendMessagePayload",
    "kind": "LinkedField",
    "name": "sendMessage",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GraphQLLlmConversation",
        "kind": "LinkedField",
        "name": "llmConversation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WelcomePageCreateConversationMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WelcomePageCreateConversationMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "59153d972eb8ca25bdae0c408f49c925",
    "id": null,
    "metadata": {},
    "name": "WelcomePageCreateConversationMutation",
    "operationKind": "mutation",
    "text": "mutation WelcomePageCreateConversationMutation(\n  $input: SendMessageInput!\n) {\n  sendMessage(input: $input) {\n    llmConversation {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b349bf11a003998068a8ea2fa673fbfc";

export default node;
